"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = (0, _runtime.IconWrapper)('loading', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#0A6CFF',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#0A6CFF'
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 14C9.09286 14 10.1175 13.7078 11 13.1973",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  })]), h("g", {
    "attrs": {
      "id": "group-1",
      "stroke": "url(#paint0_linear_852_247)",
      "fill": "url(#paint0_linear_852_247)"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 2C11.3137 2 14 4.6863 14 7.99996C14 10.2208 12.7934 12.1598 11 13.1973",
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": "paint0_linear_852_247",
      "x1": "8",
      "y1": "12",
      "x2": "8",
      "y2": "3",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#0063F4"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0063F4",
      "stop-opacity": "0.5"
    }
  })])])]), h("g", {
    "attrs": {
      "id": "group-2",
      "stroke": "url(#paint1_linear_852_247)",
      "fill": "url(#paint1_linear_852_247)"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 2C4.68629 2 2 4.6863 2 8C2 11.3137 4.68629 14 8 14",
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": "paint1_linear_852_247",
      "x1": "7.5",
      "y1": "14",
      "x2": "8",
      "y2": "3",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#0063F4",
      "stop-opacity": "0"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0063F4",
      "stop-opacity": "0.5"
    }
  })])])])]);
});
exports.default = _default;